import React, {Component} from "react";

class Login extends Component
{
	constructor(props)
	{
		super(props);

		this.state = {
		};
	}
	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		let newState = {...this.state};
		newState[name] = value;

		this.setState(newState);
	}
	handleLogin = (event) => {
		this.props.authenticate(this.state.username, this.state.password)
			.then(response => {
				this.props.setAuth(response.data.token, response.data.expires);
			})
			.catch(error => {
				console.log(error);
			});

		event.preventDefault();
	}
	render()
	{
		return (
			<div>
				<h1>Date Night</h1>
				<form id="login" onSubmit={this.handleLogin}>
					<div className="form-input">
						<label>Username</label>
						<input type="text" name="username" onChange={this.handleInputChange} />
					</div>
					<div className="form-input">
						<label>Password</label>
						<input type="password" name="password" onChange={this.handleInputChange} />
					</div>
					<input type="submit" value="Login" className="btn" />
				</form>
			</div>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js